/**
 * Mock forecast inputs used by the Financials tab until the data-service layer
 * exposes committed forecast data. The shared forecast snapshot itself lives in
 * `@/lib/mock-data/forecast-summary`.
 */

/** Hours to Complete submitted by the PM, used as estimateToComplete on the Re-estimate path. */
export const MOCK_HTC_HOURS = 142;

/** HTC-based EAC hours shown alongside the linear projection when HTC data is available. */
export const MOCK_EAC_HOURS_HTC = 1140;

/** EAC inputs for the Budget vs Actual table. ETC of 0 makes calculateEAC fall back to Simple. */
export const mockFinancialsEac = {
  actualCosts:       142000,
  totalBudget:       280000,
  completionPercent: 0.52,
  earnedValue:       145600, // 280000 × 0.52
  etc:               0,
  actualHours:       1680,
  budgetHours:       3200,
  htcHours:          MOCK_HTC_HOURS,
} as const;
